import {Component, ContentChild, Input, TemplateRef} from '@angular/core';

@Component({
  selector: 'item-with-tip',
  templateUrl: './item-with-tip.component.html',
  styleUrl: './item-with-tip.component.scss'
})
export class ItemWithTipComponent {

  @Input() icon = 'question_mark';

  @Input() tip: string;

  @Input() value = '';

  @ContentChild(TemplateRef, { static: true }) customView: TemplateRef<any>;

}
